<template>
  <div>
    <div class="section-hero">
      <video autoplay loop muted playsinline :key="heroVideo">
        <source :src="heroVideo" type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      <div class="container">
        <div class="paragraph--normal wide text-uppercase text-color-quinary">
          <span class="notranslate" translate="no">SELECTED</span> CARS
        </div>
        <div class="heading--1 fw-light text-uppercase text-color-quinary my-4">
          WITHOUT COMPROMISE
        </div>
        <div
          class="paragraph--normal wide text-uppercase text-color-quinary d-lg-block d-none"
        >
          LUXURY CAR DEALERSHIP
        </div>
        <div
          class="d-flex gap-3 justify-content-start justify-content-lg-center w-100 mt-lg-5"
        >
          <router-link
            to="/inventory"
            class="btn btn--normal btn--primary text-uppercase px-lg-5"
            >CARS FOR SALE</router-link
          >
          <router-link
            to="/about"
            class="btn btn--normal btn--primary text-uppercase px-lg-5"
            >ABOUT US</router-link
          >
        </div>
      </div>
    </div>

    <div class="section-big bg-color-tertiary">
      <div class="container">
        <div
          class="paragraph--xxxlarge wide fw-light text-uppercase text-color-quinary text-center"
        >
          Selected Cars for Exceptional Individuals.<br />
          Every vehicle in our collection is handpicked to match the<br />
          standards of those who lead, not follow.
        </div>
      </div>
    </div>

    <div class="section-normal bg-color-primary">
      <div class="container margin-bottom-9-lg margin-bottom-5">
        <div class="border-bottom-quinary padding-bottom-5-lg padding-bottom-3">
          <div class="row">
            <div class="col-lg-4 mb-lg-0 mb-4">
              <h2 class="heading--1 text-color-quinary text-uppercase mb-0">
                Our<br />
                Story
              </h2>
            </div>
            <div class="col-lg-6 offset-lg-2">
              <div class="paragraph--xlarge text-color-quinary">
                What began as a passion for extraordinary automobiles has
                evolved into a legacy of excellence. Over the years, we have
                grown into a trusted name in luxury automotive sales, known for
                meeting even the most refined expectations. Yet, at the heart of
                everything we do remains an unwavering love for automotive
                perfection — a force that continues to drive us forward.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <MasonryGallery />
      </div>
    </div>

    <div class="section-mini home-stats">
      <div class="container">
        <div class="row text-center">
          <div class="col-md-3 col-6 mb-md-0 mb-5">
            <div class="heading--0 text-uppercase mb-2 notranslate" translate="no" style="color: #111;">20+</div>
            <div class="paragraph--xlarge wide text-uppercase" style="color: #888;">Years of<br>Experience</div>
          </div>
          <div class="col-md-3 col-6 mb-md-0 mb-5">
            <div class="heading--0 text-uppercase mb-2 notranslate" translate="no" style="color: #111;">1000+</div>
            <div class="paragraph--xlarge wide text-uppercase" style="color: #888;">Cars<br>Sold</div>
          </div>
          <div class="col-md-3 col-6">
            <div class="heading--0 text-uppercase mb-2 notranslate" translate="no" style="color: #111;">16</div>
            <div class="paragraph--xlarge wide text-uppercase" style="color: #888;">Countries<br>Covered</div>
          </div>
          <div class="col-md-3 col-6">
            <div class="heading--0 text-uppercase mb-2 notranslate" translate="no" style="color: #111;">92</div>
            <div class="paragraph--xlarge wide text-uppercase" style="color: #888;">Partner<br>Dealers</div>
          </div>
        </div>
      </div>
    </div>

    <FeaturedCars :show-filter="true" />

    <AppMap />
    <AppMarquee />
  </div>
</template>

<script>
import axios from 'axios';
import AppMap from '../components/AppMap.vue';
import AppMarquee from '../components/AppMarquee.vue';
import MasonryGallery from '../components/MasonryGallery.vue';
import FeaturedCars from '../components/FeaturedCars.vue';
export default {
  components: {
    AppMap,
    AppMarquee,
    MasonryGallery,
    FeaturedCars
  },
  data() {
    return {
      heroVideo: '/frontend/assets/videos/video.mp4',
    };
  },
  mounted() {
    this.loadSettings();
    import('../seo.js').then(({ setPageSeo }) => setPageSeo({
      title: 'Selected Cars | Premium Luxury Car Dealer | Buy Cars from Europe',
      description: 'Premium European car sourcing and luxury vehicle dealership in Bratislava. Buy BMW, Mercedes-Benz, Porsche, Audi, Lamborghini, Ferrari direct from Europe. 1000+ cars delivered, 92 partner dealers across 16 countries. New and pre-owned luxury cars with door-to-door delivery.',
      keywords: 'luxury car dealer europe, buy car from europe, premium car sourcing, european car import, BMW dealer bratislava, Mercedes dealer europe, Porsche for sale europe, Audi import, Lamborghini dealer, Ferrari europe, car dealer bratislava slovakia, luxury vehicles europe, off market cars, car import service, selected cars',
      canonical: 'https://selected.sk/',
      breadcrumbs: [
        { name: 'Home', url: '/' }
      ]
    }));
  },
  methods: {
    async loadSettings() {
      try {
        const response = await axios.get('/api/settings/homepage');
        if (response.data && response.data.homepage_video) {
          this.heroVideo = response.data.homepage_video;
        }
      } catch (e) {
        // Keep default video on error
      }
    },
  },
};
</script>

<style scoped>
.home-stats {
  background: #fff;
}
</style>
